<script>
    import { createEventDispatcher } from 'svelte'
    import { get } from 'dot-prop'
    import { InputGroup, InputGroupText, InputGroupAddon, FormGroup, Input, Label } from 'sveltestrap'
    import Required from './Required.svelte'
    import ValidationMessage from './ValidationMessage.svelte'
    import DisableLock from '../fanxLight/DisableLock.svelte'

    export let context
    export let formKey
    export let index
    export let keypath // The keypath without the formKey or index, e.g. "attributes.videos.3.url"
    export let value
    export let maxLength
    export let recommendedMaxLength
    export let label
    export let placeholder = label
    export let required
    export let helptext
    export let disabled
    export let prepend
    export let orgsValue

    let charactersLeft
    let computedMessage
    value = (orgsValue || value) 

    $: formKeypath = index === undefined ? `${formKey}.${keypath}` : `${formKey}.${index}.${keypath}`
    $: isInvalid = get(context, `error.${formKeypath}.level`) === 'error'
    $: {
        const limit = recommendedMaxLength || maxLength
        const numberOfCharacters = value && value.length || 0
        charactersLeft = parseInt(limit, 10) - numberOfCharacters
    }

    $: computedClass = charactersLeft < 1
        ? maxLength
            ? 'text-danger'
            : 'text-warning'
        : 'text-muted'


    $: {
        if (recommendedMaxLength && charactersLeft < 0) {
            computedMessage = `Maximum ${recommendedMaxLength} characters recommended. Characters over: ${Math.abs(charactersLeft)}`
        } else if (recommendedMaxLength) {
            computedMessage = `Maximum ${recommendedMaxLength} characters recommended. Characters remaining: ${charactersLeft}`
        }
        computedMessage = `Maximum ${maxLength} characters. Characters remaining: ${charactersLeft}`
    }

    const dispatch = createEventDispatcher()
    const update = (event) => {
        dispatch('change', { formKey, index, keypath, value: event.target.value, context })
    }
</script>

<FormGroup>
    <Label for={formKeypath}>
        {label || ''}
        <Required {required} />
    </Label>

    {#if prepend}
        <InputGroup>
            <InputGroupAddon addonType="prepend">
                <InputGroupText>{prepend}</InputGroupText>
            </InputGroupAddon>
            <Input id={formKeypath} name={formKeypath} {placeholder} {disabled} {maxLength} {isInvalid} bind:value on:input={update}/>
        </InputGroup>
    {:else}
        <div class="component-form-field-input" on:focus>
            <div class="input-container">
                <Input id={formKeypath} name={formKeypath} {placeholder} {maxLength} {isInvalid} bind:value on:input={update} {disabled}/>
                {#if disabled}
                    <div class="disable-lock">
                        <DisableLock />
                    </div>
                {/if}
            </div>
        </div>
    {/if}

    {#if recommendedMaxLength || maxLength}
        <p class="{computedClass}">{computedMessage}</p>
    {/if}

    <ValidationMessage {context} {formKeypath} {helptext} />
</FormGroup>

<style>
    .component-form-field-input{
        position: relative;
        width: 100%
    }

    .input-container {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-evenly;
        align-items: center;
        position: relative;
    }

    .disable-lock {
        position: absolute;
        right: .4rem;
        display: flex;
        align-items: center;
    }
</style>
